import PrintIcon from '@rsuite/icons/legacy/Print';
import { Stack } from 'rsuite';
import { useCustomTheme } from '../../hooks/useCustomTheme';
import { CustomInput } from '../CustomInput';
import { CustomButton } from '../CustomButton';
import { ContainerData } from '../../pages/Relatorio/styles';

export function RelatorioFiltroPeriodo({
  dataInicio,
  dataFim,
  onChangeDataInicio,
  onChangeDataFim,
  onImprimir,
}) {
  const { theme } = useCustomTheme();

  return (
    <Stack style={{ display: 'flex', alignItems: 'flex-end' }}>
      <ContainerData style={{ display: 'flex', flexDirection: 'column' }}>
        <label htmlFor="dataInicio" style={{ color: theme.colors.text }}>
          Data Inicial{' '}
        </label>
        <CustomInput
          type="date"
          value={dataInicio}
          onChange={onChangeDataInicio}
        />
      </ContainerData>
      <ContainerData style={{ display: 'flex', flexDirection: 'column' }}>
        <label htmlFor="dataFim" style={{ color: theme.colors.text }}>
          Data Final{' '}
        </label>
        <CustomInput type="date" value={dataFim} onChange={onChangeDataFim} />
      </ContainerData>

      {onImprimir && (
        <CustomButton appearance="primary" onClick={onImprimir}>
          <PrintIcon style={{ width: 22, height: 22 }} />
        </CustomButton>
      )}
    </Stack>
  );
}
